import CityPageTemplate from "../city-template/CityPageTemplate";
import { harrisonburgVaConfig } from "./data";

export default function HarrisonburgVaPage() {
  return <CityPageTemplate config={harrisonburgVaConfig} />;
}